<template>
  <div style="width:100%;height:100%;">
    <div
      style="width:100%;height:100%;position: absolute;
        top: 0px;
        left: 0px;
        z-index: 0;
        pointer-events:auto;"
    >
      <three :alarms="alarms"></three>
    </div>
    <div class="header">
      <div class="title">
        <p style="font-size: .15rem;">离心机数字孪生系统</p>
      </div>
    </div>
    <div class="content">
      <div class="leftbg"></div>
      <div class="left">
        <div class="leftone">
          <leftOne :variable3DS="variable3DSOne"></leftOne>
        </div>
        <div class="lefttwo">
          <leftTwo :variable3DS="variable3DSTwo"></leftTwo>
        </div>
        <div class="leftthree">
          <leftThree :variable3DS="variable3DSThree"></leftThree>
        </div>
      </div>
      <div class="rightbg"></div>
      <div class="right">
        <div class="rightone">
          <rightOne></rightOne>
        </div>
        <div class="rightthree">
          <rightThree></rightThree>
        </div>
        <div class="righttwo">
          <rightTwo></rightTwo>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mqtt from "mqtt";
import leftOne from "./leftOne.vue";
import leftTwo from "./leftTwo.vue";
import leftThree from "./leftThree.vue";
import rightOne from "./rightOne.vue";
import rightTwo from "./rightTwo.vue";
import rightThree from "./rightThree.vue";
import three from "./three.vue";
export default {
  components: {
    leftOne,
    leftTwo,
    leftThree,
    rightOne,
    rightTwo,
    rightThree,
    three,
  },
  data() {
    return {
      serialNumber: "",
      code: "",
      client: "",
      variable3DSOne: [],
      variable3DSTwo: [],
      variable3DSThree: [],
      alarms: "",
    };
  },
  methods: {
    mqttMSG() {
      console.log(`3D${this.serialNumber}-${this.code}`);
      const options = {
        connectTimeout: 40000,
        clientId: `3D${this.serialNumber}-${this.code}`,
        username: "yunliansuperuser",
        password: "public",
        clean: true,
      };
      this.client = mqtt.connect(this.$wssURL, options);
      if (this.client.connected) {
        this.client.end();
      }
      // mqtt连接
      this.client.on("connect", (e) => {
        console.log("连接成功:");
        this.client.subscribe(`3D-data/${this.serialNumber}`, (error) => {
          if (!error) {
            console.log("订阅成功");
          } else {
            console.log("订阅失败");
          }
        });
      });
      // 接收消息处理
      this.client.on("message", (topic, message) => {
        // console.log("收到来自", topic, "的消息", message.toString());
        // console.log(JSON.parse(message.toString()));
        let data = JSON.parse(message.toString());
        this.variable3DSOne = [];
        this.variable3DSTwo = [];
        this.variable3DSThree = [];
        this.alarms = data.alarms;
        for (let val of data.variable3DS) {
          switch (val.alias) {
            case "电机电流":
              this.variable3DSOne.push(val);
              break;
            case "排气压力":
              this.variable3DSOne.push(val);
              break;
            case "系统压力":
              this.variable3DSOne.push(val);
              break;
            case "供油压力":
              this.variable3DSOne.push(val);
              break;
            case "排气温度":
              this.variable3DSOne.push(val);
              break;
            case "导叶阀开度":
              this.variable3DSTwo.push(val);
              break;
            case "放空阀开度":
              this.variable3DSTwo.push(val);
              break;
            case "一级轴振动":
              this.variable3DSThree.push(val);
              break;
            case "二级轴振动":
              this.variable3DSThree.push(val);
              break;
            case "三级轴振动":
              this.variable3DSThree.push(val);
              break;
            default:
              break;
          }
        }
      });
      // 断开发起重连
      this.client.on("reconnect", (error) => {
        console.log("正在重连:", error);
      });
      // 链接异常处理
      this.client.on("error", (error) => {
        console.log("连接失败:", error);
      });
    },
  },
  created() {
    document.title = "3D组态";
    let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    let maxPos = chars.length;
    for (let i = 0; i < 6; i++) {
      this.code += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    if (this.$route.query.serial_number) {
      this.serialNumber = this.$route.query.serial_number;
    }
  },
  mounted() {
    this.mqttMSG();
  },
};
</script>

<style scoped>
@import "./style.css";
.header {
  position: absolute;
  width: 100%;
  height: 6%;
  background: url(../../assets/img/centrifuge/item.png) no-repeat;
  background-size: 100% 100%;
}
.title {
  width: 15vw;
  height: 4.2vh;
  position: absolute;
  top: 1vh;
  left: 50%;
  transform: translateX(-50%);
  /* background-color: aqua; */
}
.title p {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5vw;
  color: white;
}
.content {
  height: 95%;
  width: 100%;
}
.leftbg {
  position: absolute;
  top: 6%;
  height: 94%;
  width: 1.5%;
  background: url(../../assets/img/centrifuge/leftxian.png) no-repeat;
}
.left {
  position: absolute;
  top: 6%;
  left: 2%;
  width: 22%;
  height: 92%;
  /* background: url(../assets/img/centrifuge/echartsbg.png) no-repeat;
    background-size: 100% 100%; */
}
.leftone {
  width: 100%;
  height: calc(100% / 2.72);
  background: url(../../assets/img/centrifuge/echartsbg.png) no-repeat;
  background-size: 100% 100%;
}
.lefttwo {
  margin-top: 6.5%;
  width: 100%;
  height: calc(100% / 4.79);
  background: url(../../assets/img/centrifuge/echartsbg.png) no-repeat;
  background-size: 100% 100%;
}
.leftthree {
  margin-top: 6.5%;
  width: 100%;
  height: calc(100% / 2.72);
  background: url(../../assets/img/centrifuge/echartsbg.png) no-repeat;
  background-size: 100% 100%;
}
.rightbg {
  position: absolute;
  top: 6%;
  right: 0;
  height: 94%;
  width: 1.5%;
  background: url(../../assets/img/centrifuge/rightxian.png) no-repeat;
}
.right {
  position: absolute;
  top: 6%;
  right: 2%;
  width: 22%;
  height: 92%;
  /* background-color: antiquewhite; */
}
.rightone {
  width: 100%;
  height: calc(100% / 3.2);
  background: url(../../assets/img/centrifuge/echartsbg.png) no-repeat;
  background-size: 100% 100%;
}
.righttwo {
  margin-top: 6.5%;
  width: 100%;
  height: calc(100% / 3.2);
  background: url(../../assets/img/centrifuge/echartsbg.png) no-repeat;
  background-size: 100% 100%;
  /* background-color: aqua; */
}
.rightthree {
  margin-top: 6.5%;
  width: 100%;
  height: calc(100% / 3.2);
  background: url(../../assets/img/centrifuge/echartsbg.png) no-repeat;
  background-size: 100% 100%;
}
</style>
